module.exports = __webpack_public_path__ + "img/bell.59eac426.svg";